<template>
  <div class="news-detail-page">
    <div class="news-hero">
      <img src="@/assets/images/新闻背景.png" alt="头图" />
      <div class="hero-text">
        <h1>品牌新闻<span class="en-title"> / NEWS CENTER</span></h1>
      </div>
    </div>

    <div class="news-detail-content">
      <h2>{{ $t('news.bjwo.title') }}</h2>
      <p class="meta">2024-01-26 ｜ 👁 1352</p>

      <img src="@/assets/images/allnews/bjwo/1.png" alt="bjwo 封面" />
      <p class="text-center">{{ $t('news.bjwo.content1') }}</p>
      <p>{{ $t('news.bjwo.content2') }}</p>
      <img src="@/assets/images/allnews/bjwo/2.png" alt="bjwo 封面" />
      <p>{{ $t('news.bjwo.content3') }}</p>
      <img src="@/assets/images/allnews/bjwo/3.png" alt="bjwo 封面" />
      <p>{{ $t('news.bjwo.content4') }}</p>
      <p>{{ $t('news.bjwo.content5') }}</p>
      <img src="@/assets/images/allnews/bjwo/4.png" alt="bjwo 封面" />
      <p>{{ $t('news.bjwo.content6') }}</p>
      <img src="@/assets/images/allnews/bjwo/5.png" alt="bjwo 封面" />
      <p class="text-center">{{ $t('news.bjwo.content7') }}</p>
      <p class="text-center">{{ $t('news.bjwo.content8') }}</p>
      <p class="text-center">{{ $t('news.bjwo.content9') }}</p>
      <p class="text-center">{{ $t('news.bjwo.content10') }}</p>
      <p>{{ $t('news.bjwo.content11') }}</p>
      <p>{{ $t('news.bjwo.content12') }}</p>
      <img src="@/assets/images/allnews/bjwo/6.png" alt="bjwo 封面" />
      <p>{{ $t('news.bjwo.content13') }}</p>
      <img src="@/assets/images/allnews/bjwo/7.png" alt="bjwo 封面" />
      <p>{{ $t('news.bjwo.content14') }}</p>
      <p>{{ $t('news.bjwo.content15') }}</p>
      <img src="@/assets/images/allnews/bjwo/8.png" alt="bjwo 封面" />
      <p class="text-center">{{ $t('news.bjwo.content16') }}</p>
      <p>{{ $t('news.bjwo.content17') }}</p>
      <p>{{ $t('news.bjwo.content18') }}</p>
      <img src="@/assets/images/allnews/bjwo/9.png" alt="bjwo 封面" />
      <p>{{ $t('news.bjwo.content19') }}</p>
      <p>{{ $t('news.bjwo.content20') }}</p>
      <p>{{ $t('news.bjwo.content21') }}</p>

      <div class="back">
        <router-link to="/news" class="back-button">
          <span class="arrow">←</span> 返回 / return
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'NewsBjwo' }
</script>

<style scoped>
.news-detail-page {
  background: black;
  color: white;
  padding-bottom: 60px;
}

.news-hero {
  position: relative;
  height: 230px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}
.news-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.hero-text h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
}
.en-title {
  display: inline;
  font-size: 20px;
  font-weight: normal;
  margin-left: 8px;
  letter-spacing: 0.5px;
  color: #ffb100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.news-detail-content {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}
.news-detail-content h2 {
  color: #ffb100;
  font-size: 26px;
  margin-bottom: 40px;
  text-align: center;
  padding: 0 20px;
}
.news-detail-content .meta {
  font-size: 13px;
  color: #aaa;
  margin-bottom: 20px;
  text-align: center;
}
.news-detail-content p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: left;
  text-indent: 0;
  font-size: 16px;
}
.news-detail-content img {
  width: 100%;
  margin: 20px 0;
  border-radius: 0;
  display: block;
}
.minor { color: #ffb100; margin: 16px 0; text-align: center; }
/* Utility: center only selected paragraphs */
.news-detail-content p.text-center { text-align: center; }
.back {
  margin-top: 40px;
  text-align: center;
}
.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #000;
  color: #ffb100;
  border: 1px solid #ffb100;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.back-button:hover {
  background-color: #ffb100;
  color: #000;
  border-color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 179, 0, 0.2);
}
.back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 179, 0, 0.2);
}
.arrow { margin-right: 8px; font-size: 18px; }

@media (max-width: 768px) {
  .news-hero { height: 180px; }
  .hero-text h1 { font-size: 18px; }
  .news-detail-content { max-width: 100%; margin: 20px 10px; padding: 0 10px; }
  .news-detail-content h2 { font-size: 22px; }
  .news-detail-content .meta { font-size: 12px; }
  .news-detail-content p { font-size: 14px; }
  .news-detail-content img { margin: 12px 0; }
  .back-button { padding: 8px 18px; font-size: 14px; }
}
</style>


